import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {
  constructor(private http: HttpClient) { }
}
